import styled from "@emotion/styled";
import { useQueryClient } from "@tanstack/react-query";
import { Form, message, Modal } from "antd";
import React from "react";

import { MasterBoxData, UpdateMasterBoxRequest } from "services/interface";
import SettingBoxFormEdit from "./SettingBoxFormEdit";
import { useUpdateMasterBox } from "hooks/useMasterData";

interface ModalEditProps {
  editData: MasterBoxData | undefined;
  isShow: boolean;
  onClose: () => void;
}

const ModalEdit = ({ editData, isShow, onClose }: ModalEditProps) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useUpdateMasterBox();

  const [formModal] = Form.useForm();

  const onCloseModal = () => {
    // Clear focus before closing modal
    if (document.activeElement && document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    onClose();
  };

  const onFinishModal = (values: any) => {
    console.log('✏️ [ModalEdit Component] onFinishModal called with values:', values);
    console.log('✏️ [ModalEdit Component] editData:', editData);
    
    if (!editData?.id) {
      message.error("ไม่พบข้อมูลกล่องที่ต้องการแก้ไข");
      return;
    }

    const requestData: UpdateMasterBoxRequest = {
      id: editData.id,
      name: values.name,
      description: values.description,
      width: values.width,
      height: values.height,
      length: values.length,
      weight: values.weight,
      is_active: values.is_active,
    };
    
    console.log('✏️ [ModalEdit Component] requestData:', requestData);

    mutate(requestData, {
      onSuccess: async (data) => {
        console.log('✏️ [ModalEdit Component] onSuccess response:', data);
        console.log('✏️ [ModalEdit Component] data keys:', Object.keys(data));
        console.log('✏️ [ModalEdit Component] data.success:', data.success);
        console.log('✏️ [ModalEdit Component] data.status:', (data as any).status);
        console.log('✏️ [ModalEdit Component] data.error_message:', (data as any).error_message);
        console.log('✏️ [ModalEdit Component] typeof data.success:', typeof data.success);
        
        // Check multiple possible success indicators
        const isSuccess = data.success === true || 
                         (data as any).status === 'success' || 
                         (data as any).status === 200 ||
                         (!(data as any).error_message && data.data);
        
        console.log('✏️ [ModalEdit Component] isSuccess:', isSuccess);
        
        if (isSuccess) {
          await queryClient.refetchQueries({
            queryKey: ["masterBoxes"],
            type: "active",
          });
          message.success("แก้ไขกล่องสำเร็จ");
          onCloseModal();
        } else {
          console.log('✏️ [ModalEdit Component] Success is false, showing error');
          message.error("แก้ไขกล่องไม่สำเร็จ");
        }
      },
      onError: (error) => {
        console.log('✏️ [ModalEdit Component] onError:', error);
        message.error(`แก้ไขกล่องไม่สำเร็จ: ${error.message}`);
      }
    });
  };

  return (
    <div>
      <Modal
        title="แก้ไขกล่อง"
        open={isShow}
        maskClosable={false}
        onCancel={() => {
          onClose();
        }}
        afterClose={() => {
          // Clear focus after modal is completely closed
          if (document.activeElement && document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
          }
        }}
        width={window.innerWidth <= 768 ? '95%' : 600}
        style={{ top: 20 }}
        footer={null}
        destroyOnClose={true}
        forceRender={false}
      >
        <WrapperAll>
          <SettingBoxFormEdit
            form={formModal}
            onFinish={onFinishModal}
            isPending={isPending}
            editData={editData}
            onClose={onCloseModal}
          />
        </WrapperAll>
      </Modal>
    </div>
  );
};

export default ModalEdit;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
`;
